import React from 'react';
import {Wrapper} from 'routes/App/settings/styles';
import DayItem from 'routes/App/settings/DeliveryHoursPicker/DaysPicker/DayItem';
import {useDeliveryHoursContext} from 'routes/App/settings/DeliveryHoursPicker/context/DaysPickerContext';

const DaysPicker = () => {
  const deliveryDays = useDeliveryHoursContext();

  return (
    <>
      {deliveryDays.length > 0 &&
        deliveryDays.map((day) => (
          <Wrapper key={`day-${day.id}`}>
            <DayItem day={day} withoutClose={deliveryDays.length === 1} />
          </Wrapper>
        ))}
    </>
  );
};

DaysPicker.propTypes = {};

export default DaysPicker;
